/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { BigText } from '../StyledTypography';

/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledBigPrice = BigText.withComponent('div').extend`
  font-weight: 700;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledBigPrice/index.js